import { useEffect } from 'react';
import { usePagination } from 'react-instantsearch';

import { useIndexSearch } from '@/hooks/filters/index-search.hook';


const Pagination = ({ ...props }) => {
  const { indexPage } = useIndexSearch();
  const { currentRefinement, refine } = usePagination(props);

  useEffect(() => {
    // setting the search results page here should update the hits, which will set the recoil state and render
    // the correct search results
    if (currentRefinement != (indexPage - 1)) {
      refine(indexPage - 1); // algolia search pages are 0 based
    }
  }, [indexPage]);

  return null;
};

export default Pagination;
